<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.has-text-centered
          .column
            h3.is-size-3  
              | Salida de Consumibles
              | &nbsp
              a.button.is-black.is-rounded.is-medium(@click='backPage')
                i.fas.fa-times
        .columns
          .column.is-4
            span Seleccione primero si es asignación o salida de consumibles.
          .column.is-3
            a.button(:class="isSalidaConsumible ? 'is-black':''" @click="changeSalidaCons(true)")
              | Salida a otro almacén
          .column.is-3
            a.button(:class="!isSalidaConsumible ? 'is-black':''" @click="changeSalidaCons(false)")
              | Asignación a un usuario
        .columns
          .column.is-4
            Typeahead(:options="consumibles" :optionSelect="itemData" v-model="itemSel")
          .column.is-8
            FormItem_Cons_Salida(:consumible="itemSel" @addCons_Salida="addCons_Salida" v-show="Object.keys(itemSel).length > 0")
        .columns
          .column.is-12
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Consumibles para la salida
                  | &nbsp
                  span.tag.is-black(v-if="consumibles_exit_items > 0")
                    | {{ consumibles_exit_items }} consumible(s) para la salida.
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                    ListCons_Salida(:consumibles="consumibles_exit" @deleteCons="deleteCons")
        .columns
          .column.is-12
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | {{ isSalidaConsumible ? 'Datos de Salida' : 'Datos de la Asignación'}}
                  | &nbsp
                  span.tag.is-black(v-if="Object.keys(dataForm).length > 0")
                    | Datos Completos.
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  FormCons_Salida(:usuarios="usuarios" :ubicaciones="ubicaciones" :oficinas="almacenesOrOficinas" :isSalida="isSalidaConsumible" @saveForm="saveForm")
        .columns
          .column.is-offset-5.is-2
            a.button.is-rounded(:disabled="!activarGuardar" :class="claseButton" @click="guardarSalida")
              | Guardar Salida
        .columns.column-blanco
</template>

<script>
  import Loader from '@/components/shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import Typeahead from './Typeahead.vue'
  import FormItem_Cons_Salida from './FormItem_Cons_Salida.vue'
  import FormCons_Salida from './FormCons_Salida.vue'
  import ListCons_Salida from './ListCons_Salida.vue'
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
  import InventarioServices from '../../services/inventario/inventario'
  import usuariosServices from '@/services/usuarios/usuarios'
  import moment from 'moment'

  import { mapState } from 'vuex'

  export default {
    name: 'ContainerSalida_Cons',
    components: { Loader, NavBarInventario, Typeahead, FormCons_Salida, FormItem_Cons_Salida, FormCons_Salida, ListCons_Salida, BulmaAccordion, BulmaAccordionItem },
    data() {
      return {
        isLoading: true,
        items_salida: [],
        consumibles: [],
        itemData: {},
        itemSel: {},
        habilitatarForm: false,
        consumibles_exit: [],
        consumibles_exit_items: 0,
        usuarios: [],
        usuariosSel: {},
        dataForm: {},
        activarGuardar: false,
        formCompleto: false,
        claseButton: 'is-light',
        ubicaciones: [],
        almacenes: [],
        myObjConsumibleSalida: {},
        itemsGuardados: 0,
        id_salida: '',
        fechaReg: '',
        isSalidaConsumible: true,
        origen: {},
        oficinas: [],
        almacenesOrOficinas: [],
      }
    },
    watch: {
      consumibles_exit() {
        this.checkCantidad()
      },
      formCompleto() {
        if (this.formCompleto) {
          this.activarGuardar = true
          this.claseButton = 'is-black'
        } else {
          this.activarGuardar = false
          this.claseButton = 'is-light'
        }
      },
      consumibles_exit () {
        this.checkFormularios()
      },
      dataForm () {
        this.checkFormularios()
      },
      isSalidaConsumible () {
        this.cambiarAlmacenesOrOficinas()
      },
    },
    methods: {
      iniciarComponente() {
        this.obtenerUsuarios()
      },

      obtenerConsumibles() {
        InventarioServices.getConsumiblesAlmacen(this.origen.id_oficina)
          .then(res => {
            this.consumibles = res.map(this.convetirConsumibles)
            this.itemData = this.consumibles.find( (item) => item.id == this.consumibleSelected.id)
            this.itemSel = this.itemData
            this.isLoading = false
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },

      convetirConsumibles (cons) {
        const texto = `${cons.categoria} ${cons.subcategoria !== '' ? cons.subcategoria : ''} - ${cons.marca} ${cons.modelo}`
        return {
          ...cons,
          id: parseInt(cons.id),
          text: texto,
          cantidad: parseInt(cons.cantidad),
          limite: parseInt(cons.limite),
        }
      },

      obtenerUsuarios () {
        usuariosServices.getUsuarios()
          .then( res => {
            const resp = res.map(this.convertirUsuarios)
            let userFilters = resp.filter(user => user.id !== '1538165924968' && user.id !== '1565972235101' && user.id !== '1556122430935' && parseInt(user.categoria) < 5)
            this.usuarios = userFilters
            this.obtenerUbicaciones()
            this.isLoading = false
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },

      convertirUsuarios (user) {
        return {
          ...user,
          categoria: parseInt(user.categoria),
          text: user.nombre,
          departamento: parseInt(user.departamento),
        }
      },

      obtenerAlmacenes() {
        InventarioServices.getAlmacenesConsumibles('c')
          .then( data => {
            this.almacenes = data.map(this.convertirAlmacenes)
            this.obtenerOficinas()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },

      obtenerOficinas() {
        InventarioServices.getOficinas()
          .then( data => {
            this.oficinas = data.map(this.convertirOficinas)
            this.obtenerAlmacenOrigen()
            this.cambiarAlmacenesOrOficinas()
            this.obtenerConsumibles()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },

      convertirOficinas(ofi) {
        return {
          ...ofi,
          id: parseInt(ofi.id),
          oficina: ofi.nombre,
          id_ubicacion: parseInt(ofi.id_ubicacion),
          inventario: parseInt(ofi.inventario) == 1 ? true : false,
        }
      },

      convertirAlmacenes (ofi) {
        return {
          ...ofi,
          id: parseInt(ofi.id),
          id_oficina: parseInt(ofi.id_oficina),
          id_ubicacion: parseInt(ofi.id_ubicacion),
          inventario: parseInt(ofi.inventario) == 1 ? true : false,
        }
      },

      obtenerUbicaciones() {
        InventarioServices.getUbicaciones()
          .then( data => {
            this.ubicaciones = data.map(this.convetirUbicaciones)
            this.obtenerAlmacenes()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },

      convetirUbicaciones (ubi) {
        return {
          ...ubi,
          id: parseInt(ubi.id)
        }
      },

      addCons_Salida (cons) {
        this.consumibles_exit.push(cons)
        this.itemSel = {}
        this.itemData = {}
        this.checkCantidad()
      },

      deleteCons (cons) {
        let indexOf = this.consumibles_exit.findIndex( i => i.id === cons.id)
        this.consumibles_exit.splice(indexOf,1)
        this.itemSel = {}
        this.itemData = {}
        this.checkCantidad()
      },

      saveForm(form) {
        this.dataForm = {}
        this.dataForm = Object.assign({}, this.dataForm, form)
      },

      checkFormularios() {
        if (this.consumibles_exit.length > 0 && Object.keys(this.dataForm).length > 0) {
          this.formCompleto = true
        } else {
          this.formCompleto = false
        }
      },

      checkCantidad() {
        let tot = 0
        this.consumibles_exit.forEach( cons => {
          tot = tot + Number(cons.cantidad_Exit)
        })
        this.consumibles_exit_items = tot
      },

      guardarSalida () {
        this.fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
        if (this.isSalidaConsumible) {
          InventarioServices.addConsumibleSalida(this.dataForm.fecha,this.fechaReg, this.origen.id_oficina, this.dataForm.oficina.id_oficina, this.userLogin.id, this.userLogin.nombre, this.dataForm.idUsuario_Transporta, this.dataForm.usuario_Transporta, this.dataForm.idUsuario_Entregar, this.dataForm.usuario_Entregar)
            .then((data)=> {
              if (data.success) {
                this.id_salida = parseInt(data.getData)
                this.myObjConsumibleSalida = {
                  id_salida: this.id_salida,
                  fechaReg: this.fechaReg,
                  origen: this.userLogin.ubicacion,
                  ubicacion: this.dataForm.ubicacion,
                  oficina: this.dataForm.oficina,
                  id_entrega: this.userLogin.id,
                  entrega: this.userLogin.nombre,
                  id_traslada: this.dataForm.idUsuario_Transporta,
                  traslada:this.dataForm.usuario_Transporta,
                  id_recibe:this.dataForm.idUsuario_Entregar,
                  recibe:this.dataForm.usuario_Entregar,
                  firma_entrega: '',
                  firma_traslada: '',
                  firma_recibe: '',
                  estado: 0,
                  isSalida: this.isSalidaConsumible,
                  destino_ubicacion: this.dataForm.ubicacion.nombre,
                  origen_ubicacion: this.origen.ubicacion.id,
                }

                this.guardarItems()
              } else {
                this.isLoading = false
                this.displayToast('bubble',`Error: ${data.respuesta}`, 'ban', 'OK')
              }
            })
            .catch((e)=> {
              this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
              this.isLoading = false
            })
        } else {
          InventarioServices.addConsumibleAsignacion(this.dataForm.fecha, this.fechaReg, this.origen.id_oficina, this.dataForm.oficina.id, this.userLogin.id, this.userLogin.nombre, this.dataForm.idUsuario_Entregar, this.dataForm.usuario_Entregar)
            .then((data)=> {
              if (data.success) {
                this.id_salida = parseInt(data.getData)
                this.myObjConsumibleSalida = {
                  id_asignacion: this.id_salida,
                  fechaReg: this.fechaReg,
                  origen: this.userLogin.ubicacion,
                  ubicacion: this.dataForm.ubicacion,
                  oficina: this.dataForm.oficina,
                  id_entrega: this.userLogin.id,
                  entrega: this.userLogin.nombre,
                  id_recibe:this.dataForm.idUsuario_Entregar,
                  recibe:this.dataForm.usuario_Entregar,
                  firma_entrega: '',
                  firma_recibe: '',
                  estado: 0,
                  isSalida: this.isSalidaConsumible,
                }

                this.guardarItems()
              } else {
                this.isLoading = false
                this.displayToast('bubble',`Error: ${data.respuesta}`, 'ban', 'OK')
              }
            })
            .catch((e)=> {
              this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
              this.isLoading = false
            })
        }
      },

      guardarItems () {
        if (this.itemsGuardados == this.consumibles_exit.length) {
          this.displayToast('toasted-primary', 'La Salida de consumibles se ha registrada correctamente.','done', 'ok')
          this.firmarSalidaCons(this.myObjConsumibleSalida)
        } else {
          if (this.isSalidaConsumible) {
            InventarioServices.add_consumible_exit(this.consumibles_exit[this.itemsGuardados].id, this.id_salida, this.origen.id_oficina, this.dataForm.oficina.id_oficina, this.consumibles_exit[this.itemsGuardados].cantidad_Exit)
              .then((dataItem)=> {
                if(dataItem.success) {
                  
                  InventarioServices.add_consumible_movs(this.consumibles_exit[this.itemsGuardados].id,this.fechaReg, this.consumibles_exit[this.itemsGuardados].cantidad_Exit, this.id_salida,this.dataForm.oficina.id_oficina,this.userLogin.id,this.userLogin.nombre,this.dataForm.idUsuario_Entregar,this.dataForm.usuario_Entregar, 2)
                    .then((dataMov)=> {
                      if (dataMov.success) {
                        this.itemsGuardados = this.itemsGuardados + 1
                      } else {
                        this.itemsGuardados = this.itemsGuardados + 1
                        this.displayToast('bubble',`Error: ${dataMov.respuesta}`, 'ban', 'OK')
                      }
                      this.guardarItems()
                    })
                    .catch((e3=> {
                      this.itemsGuardados = this.itemsGuardados + 1
                      this.displayToast('bubble',`Error: ${e3.message}`, 'ban', 'OK')
                      this.isLoading = false
                      this.guardarItems()
                    }))
                } else {
                  this.itemsGuardados = this.itemsGuardados + 1
                  this.displayToast('bubble',`Error: ${dataItem.respuesta}`, 'ban', 'OK')
                  this.guardarItems()      
                }
              })
              .catch((e2)=> {
                this.itemsGuardados = this.itemsGuardados + 1
                this.displayToast('bubble',`Error: ${e2.message}`, 'ban', 'OK')
                this.isLoading = false
                this.guardarItems()
              })
          } else {
            InventarioServices.add_consumible_asign(this.consumibles_exit[this.itemsGuardados].id, this.id_salida, this.origen.id_oficina, this.dataForm.oficina.id, this.consumibles_exit[this.itemsGuardados].cantidad_Exit)
              .then((dataItem)=> {
                if(dataItem.success) {
                  
                  InventarioServices.add_consumible_movs(this.consumibles_exit[this.itemsGuardados].id,this.fechaReg, this.consumibles_exit[this.itemsGuardados].cantidad_Exit, this.id_salida,this.dataForm.oficina.id,this.userLogin.id,this.userLogin.nombre,this.dataForm.idUsuario_Entregar,this.dataForm.usuario_Entregar, 3)
                    .then((dataMov)=> {
                      if (dataMov.success) {
                        this.itemsGuardados = this.itemsGuardados + 1
                      } else {
                        this.itemsGuardados = this.itemsGuardados + 1
                        this.displayToast('bubble',`Error: ${dataMov.respuesta}`, 'ban', 'OK')
                      }
                      this.guardarItems()
                    })
                    .catch((e3=> {
                      this.itemsGuardados = this.itemsGuardados + 1
                      this.displayToast('bubble',`Error: ${e3.message}`, 'ban', 'OK')
                      this.isLoading = false
                      this.guardarItems()
                    }))
                } else {
                  this.itemsGuardados = this.itemsGuardados + 1
                  this.displayToast('bubble',`Error: ${dataItem.respuesta}`, 'ban', 'OK')
                  this.guardarItems()      
                }
              })
              .catch((e2)=> {
                this.itemsGuardados = this.itemsGuardados + 1
                this.displayToast('bubble',`Error: ${e2.message}`, 'ban', 'OK')
                this.isLoading = false
                this.guardarItems()
              })
          }
        }
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema,
          position: "bottom-right", 
          duration : null,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      
      firmarSalidaCons(consumible) {
        this.$store.commit('firmarSalidaConsumible', consumible)
        this.$router.push('/Inventario/Consumibles/Firmar')
      },

      backPage () {
        this.$router.back()
      },

      changeSalidaCons (val) {
        this.isSalidaConsumible = val
      },

      obtenerAlmacenOrigen() {
        this.almacenes.map( alm => {
          const encontrado = alm.almacenistas.find( a => a.id_usuario === this.userLogin.id)
          if (encontrado) {
            this.origen = alm
          }
        })
      },

      cambiarAlmacenesOrOficinas () {
        this.almacenesOrOficinas = []
        if (this.isSalidaConsumible) {
          this.almacenesOrOficinas = this.almacenes
        } else {
          this.almacenesOrOficinas = this.oficinas
        }
      }
    },
    created () {
      this.iniciarComponente()
      
      
    },
    computed: {
      ...mapState(['userLogin', 'consumibleSelected'])
    }
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/ContainerSalida_Cons.vue